/**
 * PAGE_METADATA = {
 *   "routes": ["/ | index"],
 *   "parents": [],
 *   "children": ["/home | Homepage", "/search | Search", "/strategy | Strategy", "/services | Services", "/usecase | Data & AI Use Case", "/trainingcenter | Training Center", "/connect | Connect", "/extra | extra"],
 *   "notes": ["Portal root layout shell.", "Redirects / to /home and hosts the main business sections."]
 * };
 */
import { computed, defineComponent, provide, ref, watch } from 'vue';
import { RouterView, useRouter } from 'vue-router';
import { NScrollbar, ScrollbarInst } from 'naive-ui';

import { usePermission } from '@/hooks/usePermission';
import { formatRouterMapping, routesMenusNew } from '@/router';

import Header from './components/Header';
import Footer from './components/Footer';
import styles from './index.module.scss';
import AssistantBot from '@/components/AssistantBot/index.vue';
import Feedback from './components/Header/components/Feedback';
import Glossary from './components/Header/components/Glossary';
import { useModalStore } from '@/store/modal';
import PinToTop from '@/components/PinToTop/index.vue';

const Layout = defineComponent({
  provide() {
    const { userPermission, accountId, username } = usePermission();
    return {
      userPermission,
      accountId,
      username,
      routerPath: formatRouterMapping(routesMenusNew.children ?? []),
    };
  },

  setup: () => {
    const assRef = ref();
    const scrollRef = ref<ScrollbarInst>();
    const globalScrollTop = ref(0);
    const router = useRouter();
    const modal = useModalStore();
    const showFloatingTools = computed(() => router.currentRoute.value.name !== 'digitalLiteracy');

    provide('globalScrollTop', globalScrollTop);
    provide('scrollRef', scrollRef);

    const handleScroll = (e: Event) => {
      const target = e.target as HTMLElement;
      globalScrollTop.value = target.scrollTop;
    };

    watch(
      () => router.currentRoute.value.path,
      () => {
        scrollRef.value &&
          scrollRef.value.scrollTo({
            left: 0,
            top: 0,
          });
      },
    );

    return () => (
      <div
        class={styles.layout}
        role="button"
        tabindex={0}
        onClick={() => {
          assRef.value?.chatClose();
        }}
        onKeypress={() => {}}
      >
        <NScrollbar
          class={styles.layoutScroll}
          ref={scrollRef}
          style={{ maxHeight: '100vh' }}
          size={18}
          onScroll={handleScroll}
        >
          <Header
            listenTo={() => {
              return document.querySelector('.n-scrollbar') as HTMLElement;
            }}
          />
          <RouterView />
          <div id="drawer-target" class={styles.userCenterDrawerTargrt}></div>
          {showFloatingTools.value && <AssistantBot ref={assRef} />}
          {showFloatingTools.value && <PinToTop />}
          <Footer />
          <Feedback v-model:show={modal.feedback} />
          <Glossary v-model:show={modal.glossary} />
        </NScrollbar>
      </div>
    );
  },
});
export default Layout;
